export default function Support() {
    return (
        <p>Support: support@fitfren.com</p>
    );
}